import { render, staticRenderFns } from "./RecommendKeyword.vue?vue&type=template&id=72abdf20&scoped=true&"
import script from "./RecommendKeyword.vue?vue&type=script&lang=js&"
export * from "./RecommendKeyword.vue?vue&type=script&lang=js&"
import style0 from "./RecommendKeyword.vue?vue&type=style&index=0&id=72abdf20&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72abdf20",
  null
  
)

export default component.exports